import React, { useState } from "react";

import { useFetchNotesQuery } from "../../api/index";
import { PageItem } from "./pageSlice";
import { Link as RLink } from "react-router-dom";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
//import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

const baseUrl = "";

export function PageList() {
    const {
        data: note,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useFetchNotesQuery("arf");

    let content;
    if (isLoading) {
        content = <div>Loading</div>;
    } else if (isSuccess) {
        content = <div>Loading</div>;
    } else if (isError) {
        content = <div>{error.toString()}</div>;
    }
    return <div>{content}</div>;
}

function PageItemList({ data }: { data: { [key: string]: PageItem } }) {
    const sorted = Object.values(data).sort((a, b) =>
        b.metadata.created.ts.localeCompare(a.metadata.created.ts),
    );
    return (
        <Box>
            <Card sx={{ minWidth: 275, maxWidth: 1200 }}>
                <CardContent>
                    <Typography
                        sx={{ fontSize: 14 }}
                        color="text.secondary"
                        gutterBottom
                    >
                        test.secondary and gutterBottm
                    </Typography>
                    <Typography variant="h5" component="div">
                        h5 component div
                    </Typography>
                    <Typography variant="body2">variant=body2</Typography>
                    <List>
                        {sorted.map((file) => {
                            const k = file.metadata.id ? file.metadata.id : "";
                            return <PageListItem key={k} item={file} />;
                        })}
                    </List>
                </CardContent>
                <CardActions>
                    <Button size="small">Learn</Button>
                </CardActions>
            </Card>
        </Box>
    );
}

function PageListItem({ key, item }: { key: string; item: PageItem }) {
    return (
        <ListItem key={key}>
            <ListItemText
                primary={item.title}
                secondary={
                    <React.Fragment>
                        {"extension " + item.tag + " "}
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={
                                baseUrl +
                                "/file/download/" +
                                item.metadata.id +
                                "." +
                                item.tag
                            }
                        >
                            Download
                        </a>
                        {" - "}
                        <Link
                            component={RLink}
                            to={"/file/view/" + item.metadata.id}
                        >
                            view
                        </Link>
                        {" - "}
                        <Link
                            component={RLink}
                            to={"/page/view/" + item.metadata.id}
                        >
                            page ({item.metadata.id})
                        </Link>{" "}
                        - <br />
                        <Typography
                            component="span"
                            variant="body2"
                            sx={{ color: "text.primary", display: "inline" }}
                        >
                            {"created: " + item.metadata.created.ts}
                        </Typography>
                        <br />
                        <Typography
                            component="span"
                            variant="body2"
                            sx={{ color: "text.primary", display: "inline" }}
                        >
                            {item.metadata.modified &&
                                "modified: " + item.metadata.modified.ts}
                        </Typography>
                    </React.Fragment>
                }
            />
        </ListItem>
    );
}
